module.exports = __webpack_public_path__ + "img/hero-image-non-logged-se.c9ef0588.png";